<template>
    <div>
        <vue-simple-spinner v-if="processing"></vue-simple-spinner>
        <notifications group="foo"/>
        <div v-if="webinarProcessed">
            <div v-if="webinar === undefined">
                <h3 class="text-center">Transmisja rozpocznie się 9 kwietnia o godzinie 13:00</h3>
            </div>
            <div v-else>
                <div v-if="isLive">
                    <section class="m-md-5">
                        <div class="container">
                            <div class="d-sm-flex align-items-center justify-content-center">
                                <h2 class="h1 mb-0 my-4" style="color: black;"> {{ webinar.title }} </h2>
                            </div>
                            <div class="my-5" v-html="webinar.content"></div>
                            <div v-if="webinar.live_note" class="mb-5">
                                <p class="mb-0" v-html="webinar.live_note"></p>
                            </div>
                            <hr>
                        </div>
                        <div class="jumbotron jumbotron-fluid jumbotron-home bg-white py-4">
                            <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
                                <div class="container-fluid">
                                    <div class="row live__container">
                                        <div v-bind:class="(webinar.is_chat_enabled ? 'col-xl-9 col-lg-8 col-md-12' :
                                        'col-xl-10 col-lg-8 col-md-12 offset-xl-1 offset-lg-2 offset-md-0')">
                                            <div v-if="webinar.video_url"
                                                 class="embed-responsive embed-responsive-16by9">
                                                <iframe id="vimeo-iframe" :src="webinar.video_url"
                                                        allow="autoplay; fullscreen"
                                                        allowfullscreen="" class="video" data-ready="true"
                                                        frameborder="0"></iframe>
                                            </div>
                                            <div v-else>
                                                <h3>Prosimy odświezyć stronę</h3>
                                            </div>
                                        </div>
                                        <div
                                            v-if="webinar.is_chat_enabled"
                                            class="live__chat col-xl-3 col-lg-4 col-md-10 offset-lg-0 offset-md-1 mt-lg-0 mt-md-4">
                                            <chat :chat_name="chat_name" :is_admin="is_admin" :user_id="user_id"
                                                  :webinar_uuid="webinar.uuid"></chat>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </section>
                    <!-- <div v-if="otherWebinar.id !== webinar.id" class="container d-flex justify-content-center">
                        <a v-bind:href="'/ogladaj/' + otherWebinar.id + '/' + otherWebinar.uuid" class="btn video-btn">
                            Przejdź do transmisji z {{ this.otherIsLargeAuditorium ? 'dużej auli' : 'średniej auli' }}
                        </a>
                    </div> -->
                    <!-- <div v-if="webinars.length >= 1" class="container d-flex justify-content-center"> -->
                    <div class="video-controls">
                        <div v-if="liveOtherWebinars.length >= 1" class="room">
                            <div class="video-btn-wrapper buttons">

                                <a v-for="webinar in liveOtherWebinars"
                                   class="btn video-btn-block dropdown-item mt-1 video-room-button"
                                   v-bind:href="'/ogladaj/' + webinar.id + '/' + webinar.uuid">
                                <span>
                                    Transmisja<br>
                                     {{
                                        webinar.title.replace('Transmisja - ', '').replace(' - FIT2026', '').trim()
                                    }}
                                </span>

                                </a>

                            </div>
                        </div>
                        <div class="qna">
                            <a :href="pigeonhole"
                               class="btn video-btn-block dropdown-item mt-1 video-room-button no-icon" target="_blank">Zadaj
                                pytanie</a>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <section class="m-md-5">
                        <div class="d-sm-flex align-items-center justify-content-center">
                            <h2 class="h1 mb-0 my-4" style="color: black;"> {{ webinar.title }} </h2>
                        </div>
                        <div class="my-5" v-html="webinar.content"></div>
                        <div v-if="webinar.live_note" class="mb-5">
                            <p class="mb-0" v-html="webinar.live_note"></p>
                        </div>
                        <hr>
                        <div class="embed-responsive embed-responsive-16by9 video-iframe-timer-wrapper">
                            <div id="vimeo-iframe"
                                 class="card-img-overlay video-iframe-timer display-2"
                                 v-html="timer"></div>
                        </div>
                        <hr>
                    </section>
                    <!-- <div v-if="otherWebinar.id !== webinar.id" class="container d-flex justify-content-center">
                        <a v-bind:href="'/ogladaj/' + otherWebinar.id + '/' + otherWebinar.uuid" class="btn video-btn">
                            Przejdź do transmisji z {{ this.otherIsLargeAuditorium ? 'dużej auli' : 'średniej auli' }}
                        </a>
                    </div> -->
                    <!-- <div v-if="webinars.length >= 1" class="container d-flex justify-content-center"> -->
                    <div class="video-controls">
                        <div v-if="liveOtherWebinars.length >= 1" class="room">
                            <h3>Zmień salę</h3>
                            <div class="video-btn-wrapper buttons">

                                <a v-for="webinar in liveOtherWebinars"
                                   class="btn video-btn-block dropdown-item mt-1 video-room-button"
                                   v-bind:href="'/ogladaj/' + webinar.id + '/' + webinar.uuid">
                                <span>
                                    Transmisja<br>
                                     {{
                                        webinar.title.replace('Transmisja - ', '').replace(' - FIT2026', '').trim()
                                    }}
                                </span>

                                </a>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Spinner from "vue-simple-spinner";

export default {
    props: ['user_id', 'is_admin', 'chat_name', 'webinar_id', 'webinar_uuid', 'webinars_list'],
    components: {
        Spinner
    },
    data() {
        return {
            webinarId: this.webinar_id,
            webinarUuid: this.webinar_uuid,
            webinar: {},
            webinarProcessed: false,
            processing: true,
            timer: null,
            isMarked: false,
            isOther: false,
            otherWebinar: {},
            otherIsLargeAuditorium: false,
            webinars: []
        }
    },
    mounted() {
        this.getWebinar();
        this.getOtherWebinar();
        this.webinars = this.parseWebinarsData(this.webinars_list);
        var self = this;
        if (self.timer != 'Zapraszamy') {
            setInterval(function () {
                if (self.webinar) {
                    var diffInSeconds = Math.abs(new Date() - new Date(self.webinar.video_start_date)) / 1000;
                    var hours = parseInt(diffInSeconds / 60 / 60);
                    var minutes = parseInt(diffInSeconds / 60 % 60);
                    var seconds = parseInt(diffInSeconds % 60)
                    self.timer = self.formatHour(hours) + ':' + self.formatTime(minutes) + ':' + self.formatTime(seconds);
                    if (self.timer === '00:00:00' || new Date() > new Date(self.webinar.video_start_date)) {
                        self.timer = 'Zapraszamy';
                    }
                }
            }, 1000);
        }
    },
    computed: {
        isLive() {
            if (this.webinar.video_start_date && this.timer !== null) {
                var date = new Date(this.webinar.video_start_date);
                if (new Date() >= date || this.timer < new Date()) {
                    if (this.isMarked === false) {
                        axios.post('/api/webinars/' + this.webinar.id + '/mark-attendance');
                        this.isMarked = true;
                    }

                    return true;
                }
            }

            return false;
        },
        pigeonhole() {
            const pigeonsLinks = [
                'https://pigeonhole.at/FIT26/q/7556487',
                'https://pigeonhole.at/FIT26/q/7556552',
                'https://pigeonhole.at/FIT26/q/7556563',
                'https://pigeonhole.at/FIT26/q/7556623',
                'https://pigeonhole.at/FIT26/q/7556629',
                'https://pigeonhole.at/FIT26/q/7556688',
                'https://pigeonhole.at/FIT26/q/7556693',
                'https://pigeonhole.at/FIT26/q/7556702',
                'https://pigeonhole.at/FIT26/q/7556705'
            ];
            const currentIndex = this.webinars.findIndex(webinar => webinar.uuid === this.webinarUuid);
            return pigeonsLinks[currentIndex];
        },
        otherWebinars() {
            return this.webinars.filter(webinar => webinar.uuid !== this.webinarUuid);
        },
        liveOtherWebinars() {
            const now = new Date();
            // const now = new Date(2026, 3, 10, 13, 30);
            console.log(now);
            return this.otherWebinars.filter(webinar => {
                const start = new Date(webinar.video_start_date);
                const end = new Date(webinar.video_end_date);

                return now >= start && now <= end;
            });
        }
    },
    methods: {
        getWebinar() {
            axios.post('/api/webinars/get-current', {
                webinarId: this.webinarId,
                webinarUuid: this.webinarUuid
            }).then(response => {
                this.webinar = response.data.data;
                this.webinarProcessed = true;
                this.processing = false;
            });
        },
        getOtherWebinar() {
            axios.post('/api/webinars/get-other', {
                webinarId: this.webinarId,
                webinarUuid: this.webinarUuid
            }).then(response => {
                this.isOther = true;
                this.otherWebinar = response.data.webinar;
                this.otherIsLargeAuditorium = response.data.isLargeAuditorium;
            });
        },
        formatTime(time) {
            return ('0' + time).slice(-2);
        },

        formatHour(hours) {
            if (hours < 10) {
                return '0' + hours;
            }
            return hours;
        },
        parseWebinarsData(json) {
            const data = JSON.parse(json);
            const array = data.map((webinar) => {
                return {
                    'id': webinar.id,
                    'uuid': webinar.uuid,
                    'title': webinar.title,
                    'video_start_date': webinar.video_start_date,
                    'video_end_date': webinar.video_end_date,
                }
            });
            return array;
        }
    }
}
</script>
